import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p420114410117193728',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
